import {createSlice} from "@reduxjs/toolkit";

const initialState: any = {
  portTableTab: 'economical',
  portfolioDetail: {},
  pwplList: [],
  recList: [],
  grprList: [],
  rdmpCond: {},
  scnro: {},
  qntInfo: {},
  rePercent: null
}

const rpSlice = createSlice({
  name: 'rp',
  initialState,
  reducers: {
    updatePortTableTab: (state, action) => {
      state.portTableTab = action.payload;
    },
    updatePortfolioDetail: (state, action) => {
      state.portfolioDetail = action.payload;
    },
    updatePwplList: (state, action) => {
      state.pwplList = action.payload;
    },
    updateRecList: (state, action) => {
      state.recList = action.payload;
    },
    updateGrprList: (state, action) => {
      state.grprList = action.payload;
    },
    updateRdmpCond: (state, action) => {
      state.rdmpCond = action.payload;
    },
    updateScnro: (state, action) => {
      state.scnro = action.payload;
    },
    updateQntInfo: (state, action) => {
      state.qntInfo = action.payload;
    },
    updateRePercent: (state, action) => {
      state.rePercent = action.payload;
    }
  },
});

export default rpSlice.reducer;
export const {
  updatePortTableTab,
  updatePortfolioDetail,
  updatePwplList,
  updateRecList,
  updateGrprList,
  updateRdmpCond,
  updateScnro,
  updateQntInfo,
  updateRePercent
} = rpSlice.actions;